// Data migration utility to populate Firebase with consistent candidate data
import { addCandidate } from '../services/candidateService';
import { CandidateWithMeta } from '../types';
import { db } from '../firebase/firebase-config';
import { collection, getDocs, deleteDoc, doc } from 'firebase/firestore';

// Standard candidate data that should be consistent across all devices
const standardCandidates: Omit<CandidateWithMeta, 'id' | '_id' | 'createdAt' | 'updatedAt'>[] = [
  {
    name: "ALI ABDALLA",
    email: "ali.abdalla@email.com",
    phone: "+965-9876-5432",
    jobTitle: "Senior Housemaid",
    salary: 350,
    stage: "Interviewing",
    countryApplyingTo: "Kuwait",
    passportNumber: "A1234567",
    city: "Nairobi",
    country: "Kenya"
  },
  {
    name: "JAMAL ABDALLA", 
    email: "jamal.abdalla@email.com",
    phone: "+965-8765-4321",
    jobTitle: "Barista",
    salary: 280,
    stage: "Onboarding",
    countryApplyingTo: "Kuwait", 
    passportNumber: "B2345678",
    city: "Mombasa",
    country: "Kenya"
  },
  {
    name: "SALMIN ABDALLA",
    email: "salmin.abdalla@email.com", 
    phone: "+965-7654-3210",
    jobTitle: "Heavy Truck Driver",
    salary: 450,
    stage: "Offer",
    countryApplyingTo: "Kuwait",
    passportNumber: "C3456789",
    city: "Kisumu",
    country: "Kenya"
  },
  {
    name: "NAIM ABDALLA",
    email: "naim.abdalla@email.com",
    phone: "+965-6543-2109", 
    jobTitle: "Construction Worker",
    salary: 320,
    stage: "Onboarding",
    countryApplyingTo: "Kuwait",
    passportNumber: "D4567890",
    city: "Nakuru",
    country: "Kenya"
  }
];

export const migrateStandardCandidates = async (): Promise<void> => {
  console.log('🔄 Starting candidate data migration to Firebase...');
  
  try {
    for (let i = 0; i < standardCandidates.length; i++) {
      const candidate = standardCandidates[i];
      console.log(`📝 Adding candidate ${i + 1}/${standardCandidates.length}: ${candidate.name}`);
      
      try {
        await addCandidate(candidate);
        console.log(`✅ Successfully added ${candidate.name}`);
      } catch (error) {
        console.error(`❌ Failed to add ${candidate.name}:`, error);
      }
    }
    
    console.log('✅ Migration completed successfully!');
    alert('Standard candidates have been added to Firebase. The app will now show consistent data across all devices.');
  } catch (error) {
    console.error('❌ Migration failed:', error);
    alert('Migration failed. Please check the console for details.');
  }
};

// Function to clear all existing candidates (use with caution)
export const clearAllFirebaseCandidates = async (): Promise<void> => {
  if (!window.confirm('⚠️ WARNING: This will permanently delete ALL candidates from Firebase. Are you sure?')) {
    return;
  }
  
  console.log('🗑️ Clearing all Firebase candidates...');
  
  try {
    
    const candidatesRef = collection(db, 'candidates');
    const snapshot = await getDocs(candidatesRef);
    
    console.log(`Found ${snapshot.size} candidates to delete`);
    
    const deletePromises = snapshot.docs.map(candidateDoc => 
      deleteDoc(doc(db, 'candidates', candidateDoc.id))
    );
    
    await Promise.all(deletePromises);
    
    console.log('✅ All Firebase candidates cleared successfully!');
    alert(`Cleared ${snapshot.size} candidates from Firebase.`);
    
  } catch (error) {
    console.error('❌ Failed to clear Firebase candidates:', error);
    alert('Failed to clear Firebase candidates. Check console for details.');
  }
};